import type { ReactNode } from 'react'
import { create } from 'zustand'
import { BrandPageCouponSortOrderType } from 'src/pages/BrandPage'
import { AlwaysPageCouponSortOrderType } from 'src/pages/AlwaysDiscounCouponPage'

export type UnderLineType = 0 | 1

export interface MaintenanceMsgData {
  t: string
  d?: string
}

export type GlobalState = {
  purchaseHistoryUnderLineTab: UnderLineType
  brandUnderLineTab: UnderLineType
  brandSelectSortOrder: BrandPageCouponSortOrderType
  alwaysSelectSortOrder: AlwaysPageCouponSortOrderType
  alwaysSelectCategory: number
  maintenanceBlock: MaintenanceMsgData | null
  isDisplayLightUp: boolean | null
  isCheckAppInfo: boolean
  passWindowHistoryPoint: number
  autoOpenKakaoShare: boolean
  /** `/join/cert` 헤더 제목 동적 오버라이드 (null이면 라우트 meta 사용) */
  joinCertHeaderTitleOverride: ReactNode | null
}

type GlobalActions = {
  setPurchaseHistoryUnderLineTab: (value: UnderLineType) => void
  resetPurchaseHistoryUnderLineTab: () => void
  setBrandUnderLineTab: (value: UnderLineType) => void
  resetBrandUnderLineTab: () => void
  setBrandSelectSortOrder: (value: BrandPageCouponSortOrderType) => void
  resetBrandSelectSortOrder: () => void
  setAlwaysSelectSortOrder: (value: AlwaysPageCouponSortOrderType) => void
  resetAlwaysSelectSortOrder: () => void
  setAlwaysSelectCategory: (value: number) => void
  resetAlwaysSelectCategory: () => void
  setMaintenanceBlock: (value: MaintenanceMsgData) => void
  resetMaintenanceBlock: () => void
  setIsDisplayLightUp: (value: boolean | null) => void
  resetIsDisplayLightUp: () => void
  setIsCheckAppInfo: (value: boolean) => void
  resetIsCheckAppInfo: () => void
  setPassWindowHistoryPoint: (value: number) => void
  resetPassWindowHistoryPoint: () => void
  setAutoOpenKakaoShare: (value: boolean) => void
  resetAutoOpenKakaoShare: () => void
  setJoinCertHeaderTitleOverride: (value: ReactNode | null) => void
}

export type GlobalStoreType = GlobalState & GlobalActions

const initialState: GlobalState = {
  purchaseHistoryUnderLineTab: 0,
  brandUnderLineTab: 0,
  brandSelectSortOrder: 0,
  alwaysSelectSortOrder: 0,
  alwaysSelectCategory: 0,
  maintenanceBlock: null,
  isDisplayLightUp: null,
  isCheckAppInfo: false,
  passWindowHistoryPoint: 0,
  autoOpenKakaoShare: false,
  joinCertHeaderTitleOverride: null,
}
export const useGlobalStore = create<GlobalStoreType>((set) => ({
  ...initialState,
  setPurchaseHistoryUnderLineTab: (value: UnderLineType) =>
    set({ purchaseHistoryUnderLineTab: value }),
  resetPurchaseHistoryUnderLineTab: () => set({ purchaseHistoryUnderLineTab: 0 }),
  setBrandUnderLineTab: (value: UnderLineType) => set({ brandUnderLineTab: value }),
  resetBrandUnderLineTab: () => set({ brandUnderLineTab: 0 }),
  setBrandSelectSortOrder: (value: BrandPageCouponSortOrderType) =>
    set({ brandSelectSortOrder: value }),
  resetBrandSelectSortOrder: () => set({ brandSelectSortOrder: 0 }),
  setAlwaysSelectSortOrder: (value: AlwaysPageCouponSortOrderType) =>
    set({ alwaysSelectSortOrder: value }),
  resetAlwaysSelectSortOrder: () => set({ alwaysSelectSortOrder: 0 }),
  setAlwaysSelectCategory: (value: number) => set({ alwaysSelectCategory: value }),
  resetAlwaysSelectCategory: () => set({ alwaysSelectCategory: 0 }),
  setMaintenanceBlock: (value: MaintenanceMsgData) => set({ maintenanceBlock: value }),
  resetMaintenanceBlock: () => set({ maintenanceBlock: null }),
  setIsDisplayLightUp: (value: boolean | null) => set({ isDisplayLightUp: value }),
  resetIsDisplayLightUp: () => set({ isDisplayLightUp: null }),
  setIsCheckAppInfo: (value: boolean) => set({ isCheckAppInfo: value }),
  resetIsCheckAppInfo: () => set({ isCheckAppInfo: false }),
  setPassWindowHistoryPoint: (value: number) => set({ passWindowHistoryPoint: value }),
  resetPassWindowHistoryPoint: () => set({ passWindowHistoryPoint: 0 }),
  setAutoOpenKakaoShare: (value: boolean) => set({ autoOpenKakaoShare: value }),
  resetAutoOpenKakaoShare: () => set({ autoOpenKakaoShare: false }),
  setJoinCertHeaderTitleOverride: (value: ReactNode | null) =>
    set({ joinCertHeaderTitleOverride: value }),
}))

// 여러 매장을 한 번에 재설정
//
// import { create as _create } from 'zustand'
// import type { StateCreator } from 'zustand'
//
// const storeResetFns = new Set<() => void>()
//
// const resetAllStores = () => {
//   storeResetFns.forEach((resetFn) => {
//     resetFn()
//   })
// }
//
// export const create = (<T extends unknown>() => {
//   return (stateCreator: StateCreator<T>) => {
//     const store = _create(stateCreator)
//     const initialState = store.getState()
//     storeResetFns.add(() => {
//       store.setState(initialState, true)
//     })
//     return store
//   }
// }) as typeof _create
